import { useLocale } from '../contexts/LocaleContext'
import type { Locale } from '../lib/i18n'

export function LanguageToggle() {
  const { locale, setLocale, t } = useLocale()

  function pick(next: Locale) {
    if (next === locale) return
    setLocale(next)
  }

  return (
    <div
      className="hmvm-lang"
      role="group"
      aria-label={t('lang.switch')}
      data-testid="language-toggle"
    >
      <button
        type="button"
        className={locale === 'ru' ? 'is-active' : ''}
        aria-pressed={locale === 'ru'}
        onClick={() => pick('ru')}
      >
        {t('lang.ru')}
      </button>
      <span className="hmvm-lang-sep" aria-hidden="true">
        |
      </span>
      <button
        type="button"
        className={locale === 'en' ? 'is-active' : ''}
        aria-pressed={locale === 'en'}
        onClick={() => pick('en')}
      >
        {t('lang.en')}
      </button>
    </div>
  )
}
